module.exports = __webpack_public_path__ + "img/kwaiLogo@v3.13a4bad.png";